import styled from 'styled-components';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { radius } from '../../theme/radius';

export interface DashedButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export const DashedButton = styled.button<DashedButtonProps>`
  border: 1px dashed #d1d5db;
  border-radius: ${radius.pill}px;
  padding: 0 12px;
  height: 30px;
  font-size: 12px;
  color: #6b7280;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: border-color 0.15s;

  &:hover {
    border-color: #9ca3af;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
